import React, { Component } from 'react';
import { reduxForm } from 'redux-form';
import { EDIT_MENU_FORM_NAME } from 'Common/FormEnum';

class EditMenuForm extends Component {
  render() {
    return <span />;
  }
}

EditMenuForm = reduxForm({
  form: EDIT_MENU_FORM_NAME,
  enableReinitialize: true,
})(EditMenuForm);

export { EditMenuForm };



// WEBPACK FOOTER //
// ./src/pages/managemenu/subpages/editmenu/components/EditMenuForm.js